angular.module('qkr').factory('rnaService', ($http, appConfig) => {

    return {
        getRnaConfig: () => {
            return $http.get(appConfig.apiUrl + 'rna/getRnaConfig', {withCredentials: true});
        }
    };
});



// WEBPACK FOOTER //
// ./src/services/rna.service.js